import React, { FunctionComponent } from 'react';

interface IProps {
  num: number;
}

// This is the same code, but extracted out to be reused elsewhere
const TabArea: FunctionComponent<IProps> = ({ num }) => (
  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-50 !text-xs text-white">
    {num}
  </div>
);
export default TabArea;
